import * as types from "./mutations.types";
import { urls, axios, http } from "../../../../../services";

export const actionShowDialog = async ({ commit }) => {
  commit(types.SET_SHOW);
};

export const actionSetItem = async ({ commit, dispatch }, payload) => {
  http
    .GET(urls.monitoring, payload)
    .then(response => {
      const monitoring = response.data;
      let date = new Date(monitoring.date);
      monitoring.date = `${date.getDate()}/${date.getMonth() +
        1}/${date.getFullYear()}`;
      commit(types.SET_ITEM, monitoring);
      dispatch("actionSetImages", response.data.images);
    })
    .catch(error => console.log(error));
};

// eslint-disable-next-line no-unused-vars
export const actionSetImages = async ({ commit }, payload) => {
  let images = [];
  if (payload != undefined) {
    payload.forEach(({ path }) => {
      axios
        .get(`${urls.rawImage}${path}`, {
          responseType: "blob"
        })
        .then(response => {
          let reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onloadend = () => {
            images.push(reader.result);
          };
        })
        .catch(error => console.log(error));
    });
    commit(types.SET_IMAGES, images);
  }
};
